import HiddenIdTypeaheadController from './hidden_id_typeahead_controller'

// The template-preview contact picker (#295): typeahead over the workspace contact-
// suggestions endpoint, purpose-built to write a hidden contact_id and reload the
// preview Turbo Frame on pick. The combobox mechanics live in the shared base
// (HiddenIdTypeaheadController); this subclass names the option row (name + email) and
// submits the enclosing GET form on select.
//
// Deliberately NOT contact-autocomplete: that controller fills an editable email input
// (no hidden id, no frame reload). Here the visible input is a label and the submitted
// value is the hidden contact_id — the name states the difference.
export default class extends HiddenIdTypeaheadController {
  optionMarkup(contact, index) {
    const id = `contact-suggestion-${index}`
    const email = this.escape(contact.email)
    // Primary line = name when present, else the email. Only show the muted email as a
    // SECOND line when there is a distinct name, so a nameless contact shows its email
    // exactly once (never a blank bold line or a duplicated address).
    const primary = this.escape(contact.name || contact.email)
    const secondary = contact.name ? `<span class="text-muted small ms-1">${email}</span>` : ''
    return `
      <li id="${id}" role="option" aria-selected="false" class="list-group-item list-group-item-action" data-index="${index}"
          data-action="mousedown->contact-combobox#choose">
        <span class="fw-semibold">${primary}</span>${secondary}
      </li>`
  }

  // Picking a contact reloads only the preview frame — write the id (base behaviour),
  // show the always-present label, then submit the enclosing GET form
  // (data-turbo-frame="template_preview").
  select(contact) {
    if (!contact) return

    super.select(contact)
    this.inputTarget.value = contact.label // display_name — present even for a nameless contact
    this.element.closest('form')?.requestSubmit()
  }
}
